export type Campus = {
  sigla: string;
  name: string;
};

export const campiArray: Campus[] = [
  {
    "sigla": "AR",
    "name": "Campus Arcos"
  },
  {
    "sigla": "BI",
    "name": "Campus Bambuí"
  },
  {
    "sigla": "BT",
    "name": "Campus Betim"
  },
  {
    "sigla": "BD",
    "name": "Campus Bom Despacho"
  },
  {
    "sigla": "CO",
    "name": "Campus Congonhas"
  },
  {
    "sigla": "CL",
    "name": "Campus Conselheiro Lafaiete"
  },
  {
    "sigla": "FG",
    "name": "Campus Formiga"
  },
  {
    "sigla": "GV",
    "name": "Campus Governador Valadares"
  },
  {
    "sigla": "IB",
    "name": "Campus Ibirité"
  },
  {
    "sigla": "IP",
    "name": "Campus Ipatinga"
  },
  {
    "sigla": "IT",
    "name": "Campus Itabirito"
  },
  {
    "sigla": "JM",
    "name": "Campus João Monlevade"
  },
  {
    "sigla": "OB",
    "name": "Campus Ouro Branco"
  },
  {
    "sigla": "OP",
    "name": "Campus Ouro Preto"
  },
  {
    "sigla": "PI",
    "name": "Campus Piumhi"
  },
  {
    "sigla": "PN",
    "name": "Campus Ponte Nova"
  },
  {
    "sigla": "RI",
    "name": "Campus Ribeirão das Neves"
  },
  {
    "sigla": "SA",
    "name": "Campus Sabará"
  },
  {
    "sigla": "SL",
    "name": "Campus Santa Luzia"
  },
  {
    "sigla": "SJ",
    "name": "Campus São João Evangelista"
  }
];